import { render, staticRenderFns } from "./GRadioButton.vue?vue&type=template&id=43dd6edc&"
import script from "./GRadioButton.vue?vue&type=script&lang=ts&"
export * from "./GRadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./GRadioButton.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports